// A board holds 5 to 10 prompts. Shared by the server's check and the pack page's counter.
export const BOARD_MIN = 5;
export const BOARD_MAX = 10;
